import * as MD from '@material-ui/core/';
import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { ILayoutState } from '../../Store/Layout/Types';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';

import {alpha} from '@material-ui/core/styles';

interface IPropsFromState {
    i18n: I18N;
    layout: ILayoutState;
    localeInfos: ILocaleInfos;
    router: RouteComponentProps<{}>;
}

interface IPropsFromDispatch {
}

type AllProps =
    MD.WithTheme &
MD.WithStyles<typeof styles> &
    IPropsFromState &
    IPropsFromDispatch &
    RouteComponentProps<{}> &
    IConnectedReduxProps;

const styles = (theme:any) => MD.createStyles({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        border: '1px solid #e2e2e1',
        overflow: 'hidden',
        borderRadius: 4,
        //backgroundColor: theme.palette.background.paper,
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:hover': {
            //backgroundColor: '#fff',
        },
        '&$focused': {
            //backgroundColor: '#fff',
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: theme.palette.primary.main,
        },
    },
    focused: {},
    
});

export class DrawerComponent extends React.Component<AllProps> {

    public constructor(props: AllProps) {
        super(props);
    }

    public componentDidMount(){
               
    }
    
    public render(): React.ReactNode {
        return this.props.layout.drawerContent
    }
}
const mapStateToProps = ( { layout, i18n, ui, search } : IApplicationState, ownProps: RouteComponentProps<{}>) => ({
    layout,
    localeInfos: i18n.localeInfos,
    i18n: i18n.i18n,
    router: ownProps,
    ui,
    search
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
});

export const Drawer =
    connect(mapStateToProps, mapDispatchToProps)(MD.withTheme(MD.withStyles(styles)( DrawerComponent)));